import React, { Fragment, useEffect, useState } from 'react';
import { Card, CardBody, Badge, CustomInput, Button } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import parse from 'html-react-parser';

import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import ServiceFormButton from './ServiceFormButton';

const ServiceListItem = ({
  item,
  toggleModal,
  isHostedPage,
  isServiceOrder,
  allAddonCategoryData,
  allMembershipGroupData,
  LoadData,
  languageCode,
}) => {
  const [categoryColor, setCategoryColor] = useState([]);
  function generateRandomColor() {
    var arr = [
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger',
      'light',
      'dark',
    ];
    return arr[Math.floor(Math.random() * arr.length)];
  }
  function generateRandomColorCategory(category) {
    var arr = [
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger',
      'light',
      'dark',
      'orange',
      'blue',
      'violet',
      'light-red',
      'sky-blue',
      'outline-primary',
      'outline-secondary',
      'outline-info',
      'outline-success',
      'outline-warning',
      'outline-danger',
      'outline-light',
      'outline-dark',
    ];
    return arr[category];
  }
  const GetTypes = (text) => {
    var result = text;
    if (text === 'ServiceActivity') {
      result = 'Service or Activity';
    } else if (text === 'aivaVoucher') {
      result = 'aiva Voucher';
    } else if (text === 'RoomService') {
      result = 'Room Service';
    } else if (text === 'InformationOnly') {
      result = 'Information Only';
    } else if (text === 'InformationAction') {
      result = 'Information & Action';
    } else if (text === 'InformationPrice') {
      result = 'Information, Pricing & Action';
    } else if (text === 'TitleAction') {
      result = 'Title & Action';
    } else if (text === 'StayDetails') {
      result = 'Stay Details';
    }
    return result;
  };
  useEffect(() => {
    var cate = [];
    allAddonCategoryData.map((item, i) => {
      cate.push({
        label: item.id,
        color: generateRandomColorCategory(i),
      });
    });
    setCategoryColor(cate);
  }, [item, allAddonCategoryData]);

  return (
    <Colxx xxs="12">
      <Card className="d-flex flex-row mb-3">
        <div className="pl-0 d-flex flex-grow-1 min-width-zero col-2">
          <img
            alt="Thumbnail"
            src={
              item.imageLink != ''
                ? item.imageLink
                : 'https://via.placeholder.com/250x150'
            }
            className="list-thumbnail responsive border-0"
          />
          <Badge
            key={0}
            className="position-absolute badge-top-left"
            color={generateRandomColor()}
            pill
          >
            {item.isGlobal ? 'Global' : 'Property'}
          </Badge>
        </div>
        <div className="pl-2 d-flex flex-grow-1 min-width-zero col-10">
          <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
            <p className="mb-1  text-small w-15 w-sm-100">
              <b>{item.title}</b>
            </p>
            <p className="mb-1  text-small w-15 w-sm-100">
              <b>{GetTypes(item.type)}</b>
            </p>
            <p className="mb-1 text-muted text-small w-20 w-sm-100">
              {parse(
                item.displayText.length > 50
                  ? item.displayText.substring(0, 50) + ' ...'
                  : item.displayText
              )}
            </p>
            <p className="mb-1 text-muted text-small w-25 w-sm-100 text-center pl-2">
              {item.categoryId !== undefined &&
                item.categoryId !== null &&
                item.categoryId.length > 0 &&
                item.categoryId.map((cat) => (
                  <Fragment>
                    <Badge
                      color={
                        categoryColor.length > 0 &&
                        categoryColor
                          .filter((i) => i.label === cat.id)
                          .map((e) => e.color)
                      }
                      className="mt-1 mr-1"
                    >
                      {allAddonCategoryData
                        .filter((j) => j.id === cat.id)
                        .map((elem) => elem.title)}
                    </Badge>
                  </Fragment>
                ))}
              {/* {item.categories.map((tag, index) => {
                return (
                  <Fragment key={index}>
                    {' '}
                    <Badge color={categoryColor.length > 0 && categoryColor.filter(i => i.label === tag).map((item) => item.color)} className="mt-1" >{tag}</Badge>{' '}
                  </Fragment>
                );
              })} */}
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              {item.priceRangeEnd > 0 ? (
                <Fragment>
                  {item.currency} {item.priceRangeStart} - {item.currency}{' '}
                  {item.priceRangeEnd}
                </Fragment>
              ) : (
                <Fragment>
                  {' '}
                  {item.currency} {item.priceRangeStart}
                </Fragment>
              )}
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              {item.status}
            </p>
            <div className="w-15 w-sm-100">
              <ServiceFormButton
                id={item.id}
                isHostedPage={isHostedPage}
                isServiceOrder={isServiceOrder}
                allAddonCategoryData={allAddonCategoryData}
                allMembershipGroupData={allMembershipGroupData}
                LoadData={LoadData}
                languageCode={languageCode}
              ></ServiceFormButton>
            </div>
          </div>
        </div>
      </Card>
    </Colxx>
  );
};

export default React.memo(ServiceListItem);
